<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><i>Contents</i></span></p>
<p class="toc-text"><span><a href="#/xhtml/part01">EXPRESSIONS OF LOVE: A Novel</a></span></p>
<p class="toc-text2"><span><a href="#/xhtml/chapter001">Part One: September, 1980</a></span></p>
<p class="toc-text2"><span><a href="#/xhtml/chapter002">Part Two: October, 1941</a></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">Part Three: May, 1981</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/part02" title="Link target outside of Sample"><i>A MASK OF ONE’S OWN:</i> A Novel</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">Chapter One: 1950–1951</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">Chapter Two: Autumn, 1981</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">Chapter Three: Winter, 1959–1960</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">Chapter Four: Spring, 1982</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">Chapter Five: Autumn, 1961</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">Chapter Six: Autumn, 1982</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">Chapter Seven: Winter, 1982–1983</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample">Chapter Eight: Spring, 1983</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample">Chapter Nine: Summer, 1983</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample">Chapter Ten: Autumn, 1983</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/part03" title="Link target outside of Sample">EXPRESSIONS OF LOVE (conclusion)</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample">Part Four: January, 1986</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter015" title="Link target outside of Sample">Part Five: October, 1983</span></span></p>
<p class="toc-text2"><span><span href="#/xhtml/chapter016" title="Link target outside of Sample">Part Six: June, 1986</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?06ba02ae